


































































































































































import {Component, Mixins} from 'vue-property-decorator'
import TopDappsCard from '@/components/cards/TopDappsCard.vue'
import N3StatisticsCard from '@/components/cards/N3StatisticsCard.vue'
import TrendingTokensCard from '@/components/cards/TrendingTokensCard.vue'
import RecentlyAddedCard from '@/components/cards/RecentlyAddedCard.vue'
import TwinkleEffect from '@/components/TwinkleEffect.vue'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {BlockchainVersionCollection} from '@/model/collection/BlockchainVersionCollection'
import {DappCollection} from '@/model/collection/DappCollection'
import {BlockchainHourlyCacheCollection} from '@/model/collection/BlockchainHourlyCacheCollection'
import moment from 'moment'
import {BlockchainHourlyCache} from '@/model/resource/BlockchainHourlyCache'
import {NftCollection} from '@/model/resource/NftCollection'
import {NftCollectionCollection} from '@/model/collection/NftCollectionCollection'
import TopNftsCard from '@/components/cards/TopNftsCard.vue'
import GetGasOpenModalButton from '@/components/getGas/GetGasButton.vue'
import {TokensTableItem} from '@/model/resource/TokensTableItem'
import {TokensTableItemsCollection} from '@/model/collection/TokensTableItemsCollection'
import NeoXStatisticsCard from '@/components/cards/NeoXStatisticsCard.vue'
import {ContractCollection} from '@/model/collection/ContractCollection'
import {Dapp} from '@/model/resource/Dapp'
import {NetworkStatistics, ShrikeHelper} from '@/helpers/ShrikeHelper'
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import {Swiper as SwiperClass} from 'swiper'

@Component({
  components: {
    NeoXStatisticsCard,
    TopNftsCard,
    N3StatisticsCard,
    TopDappsCard,
    RecentlyAddedCard,
    TrendingTokensCard,
    GetGasOpenModalButton,
    TwinkleEffect,
    Swiper,
    SwiperSlide,
  },
})
export default class NetworkStatsView extends Mixins(MixinScreenSize) {
  isBeginning = true
  isEnd = true

  swiper!: SwiperClass

  blockchainVersionCollection = new BlockchainVersionCollection()
  blockchainHourlyCacheCollection = new BlockchainHourlyCacheCollection()
  dappCollection = new DappCollection()
  tokensTableItemsCollection = new TokensTableItemsCollection()
  nftCollectionCollection = new NftCollectionCollection()
  contractCollection = new ContractCollection()

  neoXStatisticsCurrentDayItems: BlockchainHourlyCache[] = []
  neoXStatisticsLastWeekItems: BlockchainHourlyCache[] = []

  topDappsItems: Dapp[] = []
  recentlyAddedItems: Dapp[] = []
  trendingTokensItems: TokensTableItem[] = []
  topNftsItems: NftCollection[] = []
  neo3Statistics: NetworkStatistics | null = null

  get hasNeo3Statistics() {
    return !!this.neo3Statistics
  }

  get hasNeoXStatistics() {
    return (
      this.neoXStatisticsCurrentDayItems.length > 0 &&
      this.neoXStatisticsLastWeekItems.length > 0
    )
  }

  get swiperOption() {
    return {
      pagination: {
        el: '.network-stats-swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 24,
        },
      },
    }
  }

  async mounted() {
    await this.populateResources()
  }

  async populateResources() {
    const promises: Array<Promise<any>> = [
      this.populateN3StatisticsCard(),
      this.populateNeoXStatisticsCard(),
      this.populateTrendingTokensCard(),
      this.populateTopNftsCard(),
      this.populateRecentlyAddedDappsCard(),
      this.populateTopDappsCard(),
    ]

    await this.$await.run('loadNetworkStats', () => Promise.all(promises))

    await this.$nextTick()
    this.updateSwiper()
    this.updateEvent()
  }

  async populateN3StatisticsCard() {
    try {
      this.neo3Statistics = await ShrikeHelper.getNetworkStatistics()
    } catch (e) {
      this.neo3Statistics = null
    }
  }

  async populateNeoXStatisticsCard() {
    this.blockchainVersionCollection.networkIdentifier = 'neox/mainnet'
    this.blockchainVersionCollection.limit = 1

    try {
      const {
        data: {items},
      } = await this.blockchainVersionCollection.listBlockchainVersion()

      const neoXVersionId = items[0]?.idBlockchainVersionPk
      if (!neoXVersionId) return

      await this.populateNeoXCurrentDayItems(neoXVersionId)

      const latestItem = this.neoXStatisticsCurrentDayItems[0]
      if (!latestItem?.date) return

      await this.populateNeoXLastWeekItems(neoXVersionId, latestItem.date)
    } catch (e) {
      this.neoXStatisticsCurrentDayItems = []
      this.neoXStatisticsLastWeekItems = []
    }
  }

  async populateTopDappsCard() {
    this.dappCollection.orderBy = 'recentTransactionCount'
    this.dappCollection.asc = false
    this.dappCollection.perPage = 3
    this.dappCollection.private = false
    this.dappCollection.isDapp = true

    const {
      data: {items},
    } = await this.dappCollection.queryAsPage()

    this.topDappsItems = items
  }

  async populateRecentlyAddedDappsCard() {
    this.dappCollection.orderBy = 'publishedDate'
    this.dappCollection.asc = false
    this.dappCollection.perPage = 3
    this.dappCollection.private = false
    this.dappCollection.isDapp = null

    const {
      data: {items},
    } = await this.dappCollection.queryAsPage()

    this.recentlyAddedItems = items
  }

  async populateTrendingTokensCard() {
    this.tokensTableItemsCollection.orderBy = 'priceVariationLastDay'
    this.tokensTableItemsCollection.asc = false
    this.tokensTableItemsCollection.perPage = 3

    const {
      data: {items},
    } = await this.tokensTableItemsCollection.listTokensTableItems()

    this.trendingTokensItems = items
  }

  async populateTopNftsCard() {
    this.nftCollectionCollection.orderBy = 'monthVolume'
    this.nftCollectionCollection.asc = false
    this.nftCollectionCollection.perPage = 3
    this.nftCollectionCollection.isVisible = true
    this.nftCollectionCollection.minOrder = 0

    const {
      data: {items},
    } = await this.nftCollectionCollection.listNftCollection()

    this.topNftsItems = items
  }

  async initSwiper(swiper: SwiperClass) {
    this.swiper = swiper
    this.updateEvent()
    this.updateSwiper()
  }

  updateEvent() {
    if (!this.swiper) return

    this.isBeginning = this.swiper.isBeginning
    this.isEnd = this.swiper.isEnd
  }

  updateSwiper() {
    if (this.swiper) {
      this.swiper.update()
    }
  }

  prevSlide() {
    if (!this.swiper.isBeginning) {
      this.swiper.slidePrev()
    }
    this.updateEvent()
  }

  nextSlide() {
    if (!this.swiper.isEnd) {
      this.swiper.slideNext()
    }
    this.updateEvent()
  }

  private async populateNeoXCurrentDayItems(idBlockchainVersion: number) {
    this.blockchainHourlyCacheCollection.limit = 1
    this.blockchainHourlyCacheCollection.withoutTotal = true
    this.blockchainHourlyCacheCollection.orderBy = 'date'
    this.blockchainHourlyCacheCollection.asc = false
    this.blockchainHourlyCacheCollection.idBlockchainVersionFk = idBlockchainVersion

    const {
      data: {items},
    } = await this.blockchainHourlyCacheCollection.listBlockchainHourlyCache()

    this.neoXStatisticsCurrentDayItems = items
  }

  private async populateNeoXLastWeekItems(
    idBlockchainVersion: number,
    referenceDate: string
  ) {
    this.blockchainHourlyCacheCollection.limit = 1
    this.blockchainHourlyCacheCollection.withoutTotal = true
    this.blockchainHourlyCacheCollection.orderBy = 'date'
    this.blockchainHourlyCacheCollection.asc = true
    this.blockchainHourlyCacheCollection.startDate = moment(referenceDate)
      .subtract(1, 'week')
      .startOf('hour')
      .format()
    this.blockchainHourlyCacheCollection.idBlockchainVersionFk = idBlockchainVersion

    const {
      data: {items},
    } = await this.blockchainHourlyCacheCollection.listBlockchainHourlyCache()

    this.neoXStatisticsLastWeekItems = items
  }
}
